import { createRoute, useNavigate } from '@tanstack/react-router'
import { useContext } from 'react'
import { ChevronLeft, Globe, Mail } from 'lucide-react'
import rootRoute from './rootRoute'
import { Card, Input } from '@/components/ui'
import PasswordChange from '@/components/PasswordChange'
import { LoginContext, loggedInRouteLoader } from '@/lib/auth'

export function ProfilePage() {
  const ctx = useContext(LoginContext)
  const navigate = useNavigate()
  const user = ctx?.user

  if (!user) {
    return (
      <div style={{ padding: 'var(--space-20)', textAlign: 'center' }}>
        Vous devez être connecté pour accéder à votre profil.
      </div>
    )
  }

  return (
    <div
      style={{
        maxWidth: 760,
        margin: '0 auto',
        padding: 'var(--space-8) var(--gutter) var(--space-20)',
      }}
    >
      <button
        onClick={() => navigate({ to: '/my-events' })}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--ink-2)',
          fontSize: 14.5,
          fontWeight: 600,
          fontFamily: 'var(--font-body)',
          padding: '0 0 16px',
        }}
      >
        <ChevronLeft size={18} /> Retour à mon compte
      </button>
      <div className="oumma-overline" style={{ marginBottom: 10 }}>
        Paramètres
      </div>
      <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 28px' }}>
        Votre compte
      </h1>

      <Card padding={26} style={{ marginBottom: 22 }}>
        <h2
          style={{
            fontSize: 'var(--text-h4)',
            margin: '0 0 18px',
            fontFamily: 'var(--font-display)',
          }}
        >
          Profil
        </h2>
        <div
          className="oumma-set-grid"
          style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}
        >
          <Input
            label="Adresse e-mail"
            type="email"
            value={user.email}
            iconLeft={<Mail size={18} />}
            readOnly
          />
          <Input
            label="Méthode de connexion"
            value={user.is_oauth ? 'Google' : 'E-mail / mot de passe'}
            iconLeft={<Globe size={18} />}
            readOnly
          />
        </div>
      </Card>

      {user.is_oauth ? (
        <Card padding={26}>
          <p style={{ fontSize: 15, color: 'var(--ink-2)', margin: 0 }}>
            Vous êtes connecté via Google. La gestion du mot de passe se fait
            depuis votre compte Google.
          </p>
        </Card>
      ) : (
        <PasswordChange />
      )}
    </div>
  )
}

export const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/me',
  loader: loggedInRouteLoader as any,
}).lazy(() => import('./ProfilePage.lazy').then((m) => m.Route))

export default ProfilePage
